import { app } from './app';

import PrimeVue from 'primevue/config';


import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

import Paginator from 'primevue/paginator';
import Popover from 'primevue/popover';
import Select from 'primevue/select';

import Dialog from 'primevue/dialog';

import Tabs from 'primevue/tabs';
import Tab from 'primevue/tab';
import TabList from 'primevue/tablist';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#F4FCEB',
            100: '#E8F8D7',
            200: '#D1F1AF',
            300: '#BAEA87',
            400: '#A4E35F',
            500: '#8FDE4A',
            600: '#82D03D',
            700: '#6CAF2E',
            800: '#568D22',
            900: '#406B16',
            950: '#28450C',
        },
    },
});

app.use(PrimeVue, {
    theme: {
        preset: MyPreset,
        options: {
            prefix: 'p',
            darkModeSelector: false,
        },
    },
});

const components = {
    Paginator,
    Popover,
    Select,
    PSelect: Select,
    Dropdown: Select,
    PDropdown: Select,

    Dialog,
    PDialog: Dialog,

    Tabs,
    Tab,
    TabList,
    TabPanels,
    TabPanel,
};

Object.entries(components).forEach(([name, component]) => {
    app.component(name, component);
});
